import React from 'react'
import './Footer.scss'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <footer className="fr-footer">
            <div
                id="footer-top"
                style={{ backgroundImage: `url('images/cbb2.png')`, backgroundSize: "cover" }}
            >
                <div className="fr-footer__overlay">
                    <div className="fr-footer__inner">
                        <div className="fr-footer__brand">
                            <div className="fr-footer__logo">FlashRoom</div>
                            <p className="fr-footer__tagline">
                                Share code, notes, and files—fast.
                            </p>

                            <div className="fr-footer__status">
                                <span className="fr-dot" />
                                <span className="fr-footer__statusText">Realtime rooms • Snippets • Files</span>
                            </div>
                        </div>

                        <div className="fr-footer__cols" aria-label="Footer">
                            <div className="fr-footer__col">
                                <h4 className="fr-footer__title">Product</h4>
                                <Link to='/about' className="fr-footer__link" >About Flashroom</Link>
                                <Link to='/rooms' className="fr-footer__link" >Manage Rooms</Link>
                                <Link to='/gettingstarted' className="fr-footer__link" >Getting Started</Link>

                            </div>

                            <div className="fr-footer__col">
                                <h4 className="fr-footer__title">Quick Links</h4>
                                <Link to='/' className="fr-footer__link" >Home</Link>
                                <Link to='/join' className="fr-footer__link" >Join Room</Link>
                                <Link to='/createroom' className="fr-footer__link" >Create Room</Link>
                            </div>


                            <div className="fr-footer__col">
                                <h4 className="fr-footer__title">Policy</h4>
                                <Link to='/privacy' className="fr-footer__link" >Privacy Policy</Link>
                                <Link to='/terms' className="fr-footer__link" >Terms and Conditions</Link>
                            </div>


                            <div className="fr-footer__col">
                                <h4 className="fr-footer__title">Other Info</h4>
                                <Link to='/aboutcreator' className="fr-footer__link" >About the Creator</Link>
                                <Link to='/comingsoon' className="fr-footer__link" >Coming Soon</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="footer-bottom">
                <div className="fr-footer__bottomInner">
                    <span className="fr-footer__copyright">
                        © {new Date().getFullYear()} FlashRoom. All rights reserved.
                    </span>


                </div>
            </div>
        </footer>

    )
}

export default Footer
